import React from 'react';
import Typography from '@mui/material/Typography';
import {withStyles} from '@mui/styles';
import Container from '@mui/material/Container';
import {actions as accountActions, selectors as accountSelectors} from '../../Ducks/account';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import logo from "../../Assets/icons/f5-logo.svg"
import {AzureSignInButton} from '../../Azure/AzureSignInButton';

const useStyles = _theme => ({
    '@global': {
        body: {},
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '100px'
    },
    avatar: {},
    form: {
        width: '100%',
    },
    submit: {
        marginBottom: '5px !important'
    },
    link: {
        cursor: 'pointer'
    },
    errorMessage: {
        margin: '1rem',
        width: 'calc(100% - 28px)',
    },
});


class SignInWithMicrosoft extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoggingIn: false
        }
    }

    componentDidUpdate(prevProps) {
        const {isLoggedIn} = this.props;

        if (isLoggedIn && !prevProps.isLoggedIn) {
            this.props.history.push('/');
        }
    }

    render() {
        const {classes, loading} = this.props;
        return (
            <Container component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <img alt="F5" src={logo} className="logo-block"></img>

                    <div style={{marginTop: '50px'}}/>


                    {this.props.errorMessage && (
                        <Typography color="error" className={classes.errorMessage}>
                            {this.props.errorMessage}
                        </Typography>
                    )}

                    <AzureSignInButton disabled={loading}/>
                </div>
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: accountSelectors.loading(state),
    errorMessage: accountSelectors.errorMessage(state),
    isLoggedIn: accountSelectors.isLoggedIn(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        login: accountActions.login,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(SignInWithMicrosoft));